<template>
  <div class="banner-image-area position-relative">
    <div class="container_fl">
      <div class="row align-items-center">
        <div class="col-lg-6 order-1 order-lg-1 wow move-up text-right p-5">
          <div class="banner-image__media pl-3">
            <img
              src="../assets/img/illustrations/co-workers.svg"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-6 order-2 order-lg-2 wow move-up p-5">
          <div class="banner-image__content">
            <div class="section-title-wrapper mb-20">
              <h2 class="section-title font-weight--light">
                Generate PIF documents with ease
              </h2>
            </div>
            <div class="banner-image__text section-space--mb_40">
              Skip the tedious and repetitive work of creating PIF documents,
              automate your workflow with Apif to easily generate quality and
              compliance documents.
            </div>
            <router-link
              :to="{ path: 'go' }"
              class="ht-btn ht-btn-md section-space--mb_40 signup"
              >Try the app</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerOne",
};
</script>